import { gql, TypedDocumentNode } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";
import {
  IntentProject,
  IntentProjectSearchIntentResourcesOperationsSuggestionsArgs,
} from "types/generated";

export const SEARCH_INTENT_RESOURCES_OPERATIONS_SUGGESTIONS: TypedDocumentNode<
  { intentProject: Pick<IntentProject, "id" | "searchIntentResourcesOperationsSuggestions"> },
  { intentProjectId: string } & IntentProjectSearchIntentResourcesOperationsSuggestionsArgs
> = gql`
  query SearchIntentResourcesOperationsSuggestions(
    $intentProjectId: ID!
    $input: SearchSuggestionsInput!
  ) {
    intentProject(id: $intentProjectId) {
      id
      searchIntentResourcesOperationsSuggestions(input: $input) {
        ...SearchSuggestionsFragment
      }
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
